import { UserOutlined, AppstoreOutlined, UnorderedListOutlined, UserAddOutlined, ApartmentOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';

type MenuItem = Required<MenuProps>['items'][number];

export const adminMenuItems: MenuItem[] = [
    {
        key: 'category-editor',
        icon: <ApartmentOutlined />,
        label: '카테고리 편집 (신규)',
    },
    {
        key: 'permissions',
        icon: <SafetyCertificateOutlined />,
        label: '유저 권한 관리 (신규)',
    },
    {
        key: 'board-category-permissions',
        icon: <SafetyCertificateOutlined />,
        label: '게시판-카테고리 권한 관리',
    },
    {
        key: 'signup',
        icon: <UserAddOutlined />,
        label: '회원가입 관리',
    },
    {
        key: 'category',
        icon: <UnorderedListOutlined />,
        label: '카테고리 편집 (구버전)',
    },
    {
        key: 'boards',
        icon: <AppstoreOutlined />,
        label: '게시판 권한 관리 (구버전)',
    },
    {
        key: 'users',
        icon: <UserOutlined />,
        label: '유저 관리 (구버전)',
    },
];
